import Dateservice from 'live/services/date'
import { getExportFilenameForWidgetConfig } from 'plugin-assets/shared/widget/lib/util'

type WidgetConfig = {
    assets: Array<{
        asset: string
        channels: string
        calculatedChannels: string
        lookup: string
    }>
    filters: Array<{ id: string; values: string[] }>
    span: string
}

type WidgetState = {
    assets: unknown[]
    params: { span: string }
    widget: unknown
}

export default function downloadOptionsFor(
    widgetConfig: WidgetConfig,
    widgetState: WidgetState,
    defaultOptions = []
): Array<unknown> {
    const fn = getExportFilenameForWidgetConfig(widgetConfig, widgetState)

    const fileName = '(fileName=' + fn + ')'
    const tz = '(tz=' + Dateservice.getUserTimezoneOffset() + ')'
    const convertTmt = '(convertTimestamp)'

    const newOptions = [
        makeOption('CSV', 'Plain', 'csvPlus' + fileName + convertTmt + tz, 'csv'),
        makeOption('CSV', 'GZip', 'csvPlus' + fileName + convertTmt + tz + '.gzip', 'csv.gzip'),
        makeOption('CSV', 'ZIP', 'csvPlus' + fileName + convertTmt + tz + '.zip(single)', 'csv.zip'),

        makeOption('JSON', 'Plain', 'jsonPlus' + fileName, 'json'),
        makeOption('JSON', 'GZip', 'jsonPlus' + fileName + '.gzip', 'json.gzip'),
        makeOption('JSON', 'ZIP', 'jsonPlus' + fileName + '.zip(single)', 'json.zip'),

        makeOption('Excel', 'Plain', 'excelPlus' + fileName + convertTmt + tz, 'excel'),
        makeOption('Excel', 'GZip', 'excelPlus' + fileName + convertTmt + tz + '.gzip', 'excel.gzip'),
        makeOption('Excel', 'ZIP', 'excelPlus' + fileName + convertTmt + tz + '.zip(single)', 'excel.zip')

        // makeOption('Excel', 'Merged', 'excelPlus(convertTimestamp)(fileName=' + fn + ')' + tz, 'excel')
    ]

    return [mergeSimilar(newOptions, defaultOptions), [], fn]
}

type DownloadOption = {
    name: string
    modifier: string
    format: string
    type: string
}

function makeOption(name, modifier, format, type): DownloadOption {
    return { name, modifier, format: format, type }
}

// 1. If two elements have the same `format` but differs in `name` or `modifier` they are still the same.
function mergeSimilar(newItems: DownloadOption[], defaultItems): DownloadOption[] {
    return newItems.map(element => {
        const duplicate = defaultItems.findIndex(a => a.format === element.format)

        if (duplicate !== -1) {
            element.name = defaultItems[duplicate].name ?? element.name
            element.modifier = defaultItems[duplicate].modifier ?? element.modifier

            defaultItems.splice(duplicate, 1)
        }

        return element
    })
}
